import { render } from "./ProgramManagement.vue?vue&type=template&id=78241dc6"
import script from "./ProgramManagement.vue?vue&type=script&lang=js"
export * from "./ProgramManagement.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__